import { ApolloError, useQuery } from "@apollo/client";
import { gql } from "../__generated__";
import { GetMyProProfileQuery } from "../__generated__/graphql";

const GET_MY_PRO_PROFILE = gql(`
	query GetMyProProfile {
		myProInformation {
			id
			userId
			firstName
			lastName
			email
			yearsOfExperience
			phoneNumber
			proApplication {
				country
        dateOfBirth
        gender
        detailedAddress {
          address
          city
          state
          placeId
        }
			}
			overview
		}
	}
`);

export const useProProfile = (): {
  loading: boolean;
  error?: ApolloError;
  profile?: GetMyProProfileQuery["myProInformation"];
} => {
  const { loading, error, data } = useQuery(GET_MY_PRO_PROFILE);

  if (error && error.message.includes("Pro not found")) {
    return {
      loading: false,
    };
  }

  return {
    loading,
    error,
    ...(!!data?.myProInformation && { profile: data.myProInformation }),
  };
};
